import {GetGenderSwitchResponse_SelectedGenderNotAvailable} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.types';
import {useHistoryPageState} from '@aboutyou/history-page-state';
import {useShowToast} from '@aboutyou/ui-components';
import {useEffect, useRef} from 'react';

export const useNotifyForSelectedGenderNotAvailable = (
  selectedGenderNotAvailable?: GetGenderSwitchResponse_SelectedGenderNotAvailable,
) => {
  const showToast = useShowToast();

  const isHistoryPageStateRead = useRef(false);
  const [toastShown, setToastShown] = useHistoryPageState(false, {
    uniqueKey: 'CLP_SELECTED_GENDER_NOT_AVAILABLE',
  });

  if (toastShown) {
    isHistoryPageStateRead.current = true;
  }

  useEffect(() => {
    if (
      isHistoryPageStateRead.current ||
      toastShown ||
      !selectedGenderNotAvailable
    ) {
      return;
    }

    showToast({
      type: 'WARNING',
      content: selectedGenderNotAvailable.toastMessage,
    });

    // eslint-disable-next-line local-rules/set-state-in-use-effect
    setToastShown(true);
  }, [selectedGenderNotAvailable, setToastShown, showToast, toastShown]);
};
